
import { Code24Filled, Code24Regular ,bundleIcon} from "@fluentui/react-icons";

export const CodeIcon = bundleIcon(Code24Filled, Code24Regular);